/** 
 * 获取元素左上角相对页面顶部距离
 * @param dom {Object} - 原生对象 
 */

const getDomOffsetHeight = (dom) => {
    if (!dom) {
        window.console.warn('请传入dom元素')
        return
    }
    let offsetHeight = 0
    const getOffsetHeight = (dom) => {
        offsetHeight += parseInt(dom.offsetTop || 0)
        if (dom.parentNode) {
            getOffsetHeight(dom.parentNode)
        }
    }
    getOffsetHeight(dom)
    return offsetHeight
}

export default getDomOffsetHeight